import { takeLatest, put, call, all } from "redux-saga/effects";
import { StatusCountActionTypes } from "./status-count.types";
import {
  fetchStatusCountSuccess,
  fetchStatusCountFailure,
  fetchAgentsSuccess,
  fetchAgentsFailure,
  fetchAgentsChanged,
  fetchStatusCountChanged,
} from "./status-count.action";
import { getStatusCount, getAgents } from "./status-count.service";
import { encryptData } from "../../_common/enode-decode";

export function* fetchStatusCountAsync({
  payload,
}: any): Generator<any, void, any> {
  try {
    const jsonData = {
      ResponseType: payload.ResponseType,
      Year: payload.Year,
      Month: payload.Month,
      UserTypeName: payload.UserTypeName,
      FromDate: payload.FromDate,
      ToDate: payload.ToDate,
      AgentID: payload.AgentID,
      InstanceName: payload.InstanceName,
      UserLevel: payload.UserLevel,
    };
    const StatusCountData = encryptData(jsonData, "StatusCountKey");
    const response = yield call(getStatusCount, StatusCountData);
    yield put(fetchStatusCountSuccess(response.data));
  } catch (error) {
    yield put(fetchStatusCountFailure(error));
  }
}

export function* watchStatusCount() {
  yield takeLatest(
    StatusCountActionTypes.FETCH_STATUS_COUNT_START,
    fetchStatusCountAsync,
  );
}

export function* fetchStatusCountReset() {
  yield put(fetchStatusCountChanged());
}

export function* watchStatusCountReset() {
  yield takeLatest(
    StatusCountActionTypes.STATUS_COUNT_RESET,
    fetchStatusCountReset,
  );
}

export function* fetchAgentsAsync({ payload }: any): Generator<any, void, any> {
  try {
    const jsonData = {
      UserID: payload.userID,
      InstanceName: payload.InstanceName,
    };
    const AgentData = encryptData(jsonData, "GetAllLeadSourceKey");
    const response = yield call(getAgents, AgentData);
    yield put(fetchAgentsSuccess(response.data));
  } catch (error) {
    yield put(fetchAgentsFailure(error));
  }
}

export function* watchAgents() {
  yield takeLatest(StatusCountActionTypes.FETCH_AGENTS_START, fetchAgentsAsync);
}

export function* fetchAgentsReset() {
  yield put(fetchAgentsChanged());
}

export function* watchAgentsReset() {
  yield takeLatest(StatusCountActionTypes.AGENTS_LIST_RESET, fetchAgentsReset);
}

export function* statusCountSaga() {
  yield all([
    call(watchStatusCount),
    call(watchStatusCountReset),
    call(watchAgents),
    call(watchAgentsReset),
  ]);
}
